import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useCurrentBranch } from '../../../../hooks/useCurrentBranch';
import { store as notificationStore } from 'react-notifications-component';
import Logo from '../../../../assets/logo.svg'
import CarouselComponent from "./CarouselComponent/CarouselComponent";
import Balance from "./Balance/Balance";
import styles from './AccountInfo.module.css'

export default function AccountInfo() {
  const info = useSelector(s => s.profileReducer.info);
  const dispatch = useDispatch();
  const history = useHistory();
  const { hasActiveSubscription } = useCurrentBranch();

  const handleLogoClick = (e) => {
    if (!hasActiveSubscription) {
      e.preventDefault();
      notificationStore.addNotification({
        title: 'Доступ ограничен',
        message: 'Для активации программы лояльности свяжитесь с отделом продаж',
        type: "warning",
        insert: "top",
        container: "top-right",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
          duration: 5000,
          onScreen: true
        }
      });
    }
  };

  return (
      <div className={styles.container}>
          <Link to="/" onClick={handleLogoClick}>
            <img src={Logo}/>
          </Link>
          <CarouselComponent
            branches={info ? info.branches : []}
          />
          {/*<Balance/>*/}
      </div>
  )
}